export default __webpack_public_path__ + "fb43e96902d0e3e6f6f4059738fec898.png";